"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deviceMax = exports.device = void 0;
var size = {
  small: '375px',
  medium: '800px',
  large: '1024px',
  xLarge: '1920px'
};
/**
 * @mobile 375px
 * @midSize 800px
 * @tablet 1024px
 * @desktop 1920px
 */

var device = {
  mobile: "(min-width: ".concat(size.small, ")"),
  midSize: "(min-width: ".concat(size.medium, ")"),
  tablet: "(min-width: ".concat(size.large, ")"),
  desktop: "(min-width: ".concat(size.xLarge, ")")
};
exports.device = device;
var deviceMax = {
  mobile: "(max-width: ".concat(size.small, ")"),
  midSize: "(max-width: ".concat(size.medium, ")"),
  tablet: "(max-width: ".concat(size.large, ")"),
  desktop: "(max-width: ".concat(size.xLarge, ")")
};
exports.deviceMax = deviceMax;